import { Mutation, MutationTree } from "vuex";
import { HomePageMutation, HomePageState } from "@/components/homePage/types";

export const mutations: MutationTree<HomePageState> &
  Record<HomePageMutation, Mutation<HomePageState>> = {
  [HomePageMutation.setPlayedChannelIndex](state, index?: number) {
    state.playedChannelIndex = index;
  }
};
